/**
 * API 请求插件
 * 统一处理请求拦截、响应拦截、错误处理
 */

/**
 * 处理 401 未授权错误
 */
function handleUnauthorized() {
  useCookie('auth_token').value = null
  navigateTo('/login')
}

/**
 * 显示错误消息（仅在客户端）
 */
function showError(message: string) {
  if (import.meta.client) {
    ElMessage.error(message)
  }
}

/**
 * 处理 HTTP 状态码错误
 */
function handleHttpError(status: number, message?: string) {
  switch (status) {
    case 401:
      handleUnauthorized()
      break
    case 403:
      showError('没有权限访问')
      break
    case 404:
      showError('资源不存在')
      break
    case 500:
      showError(message || '服务器错误')
      break
    default:
      showError(message || '请求失败')
  }
}

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  
  const api = $fetch.create({
    baseURL: config.public.apiBase || '/api',
    
    // 请求拦截器
    onRequest({ options }) {
      const token = useCookie('auth_token').value

      // 设置请求头
      options.headers.set('Content-Type', 'application/json')

      // 统一添加登录平台标识
      options.headers.set('X-Login-Platform', '7')

      // 添加 Token
      if (token) {
        options.headers.set('Authorization', `Bearer ${token}`)
      }
    },
    
    // 请求错误拦截
    onRequestError({ error }) {
      console.error('请求错误:', error)
    },
    
    // 响应拦截器（处理业务状态码）
    onResponse({ response }) {
      const res = response._data
      
      // 业务状态码判断
      if (res && typeof res.code === 'number' && res.code !== 200) {
        const errorMessage = res.msg || '请求失败'
        handleHttpError(res.code, errorMessage)
        
        // 抛出业务错误，让调用处可以 catch
        throw new Error(errorMessage)
      }
    },
    
    // 响应错误拦截（处理 HTTP 状态码）
    onResponseError({ response }) {
      const errorMessage = response._data?.message || response._data?.msg
      handleHttpError(response.status, errorMessage)
    },
  })

  return {
    provide: {
      api,
    },
  }
})
